import React from "react"
import HomeSlider from "./HomeSlider";
import SpotCard from "./SpotCard";
import UpcomingCard from "./UpcominCard";

//animation library
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

AOS.init();



const Home = ({ darkMode }) => {

    return (
        <div className={`overflow-hidden ${darkMode ? '_dark_mode' : ''}`}>
            <div className="_hero_nft_wrapper">
                {
                    darkMode && (
                        <div className="_dark_nft_shape _dark_nft_shape_right">

                        </div>
                    )
                }
                <div className="_hero_nft_wrap">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div data-aos="fade-right" data-aos-duration="1500" className="_hero_nft_left_wrap">
                                    <div className="_hero_nft_left_inner">
                                        <div className="_hero_nft_left_card_wrap">
                                            <div className="_hero_nft_left_card_wrap_inner">
                                                <div className="_hero_nft_left_card_top">
                                                    <img src="assets/img/headerimg.png" alt="allblocks" className="_hero_nft_left_card_img" />
                                                </div>
                                                <div className="_hero_nft_left_card_btm">
                                                    <div className="_hero_nft_left_card_btm_prfl">
                                                        <img src="assets/img/p1.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                        <img src="assets/img/p2.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                        <img src="assets/img/p3.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                        <img src="assets/img/p4.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                    </div>
                                                    <h4 className="_hero_nft_left_card_btm_title">ArtCrypto</h4>
                                                    <div className="_hero_nft_left_card_btm_point">
                                                        <div className="_hero_card_btm_point_left">
                                                            <img src="assets/img/eth.svg" alt="allblocks" className="_hero_card_btm_point_left_img" />
                                                            <p className="_hero_card_btm_point_left_num">0.25 ETH</p>
                                                        </div>
                                                        <p className="_hero_nft_left_card_btm_point_right">1 of 321</p>
                                                    </div>
                                                    <div className="_hero_nft_left_card_btm_time_wrap">
                                                        <p className="_hero_nft_left_card_btm_time">3h 50m 2s left</p>
                                                        <a href="#0" className="_hero_nft_left_card_btm_link">Place a bid</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="_hero_nft_left_card_wrap _card_back">
                                            <div className="_hero_nft_left_card_wrap_inner">
                                                <div className="_hero_nft_left_card_top">
                                                    <img src="assets/img/headerimg.png" alt="allblocks" className="_hero_nft_left_card_img" />
                                                </div>
                                                <div className="_hero_nft_left_card_btm">
                                                    <div className="_hero_nft_left_card_btm_prfl">
                                                        <img src="assets/img/p1.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                        <img src="assets/img/p2.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                        <img src="assets/img/p3.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                        <img src="assets/img/p4.png" alt="allblocks" className="_hero_nft_left_card_prfl_img" />
                                                    </div>
                                                    <h4 className="_hero_nft_left_card_btm_title">ArtCrypto</h4>
                                                    <div className="_hero_nft_left_card_btm_point">
                                                        <div className="_hero_card_btm_point_left">
                                                            <img src="assets/img/eth.svg" alt="allblocks" className="_hero_card_btm_point_left_img" />
                                                            <p className="_hero_card_btm_point_left_num">0.25 ETH</p>
                                                        </div>
                                                        <p className="_hero_nft_left_card_btm_point_right">1 of 321</p>
                                                    </div>
                                                    <div className="_hero_nft_left_card_btm_time_wrap">
                                                        <p className="_hero_nft_left_card_btm_time">3h 50m 2s left</p>
                                                        <a href="#0" className="_hero_nft_left_card_btm_link">Place a bid</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div data-aos="fade-left" data-aos-duration="1000" className="_hero_nft_right_wrap">
                                    <h2 className="_hero_nft_right_title">FINALLY FREEDOM TO COLLECT AND SELL
                                        THE MOST AMAZING NFTs UNSTUCK FROM CHAINS</h2>
                                    <p className="_hero_nft_right_txt">AllBlocks is a pioneering new generation of multichain cross
                                        chain
                                        NFT protocol, to launch and host assets and projects cohabited on
                                        Ethereum, Solana, Tezos, Cardano, Avalanche, Tron and BSC for
                                        the first time</p>
                                    <h3 className="_hero_nft_right_btm_title">GET REWARDED TRADING NFTs OF MULTIPLE
                                        CHAINS</h3>
                                    <div className="_hero_nft_right_btm_btn">
                                        <a href="reward" className="_hero_nft_right_btm_btn1">Start Earning</a>
                                        <a href="explore" className="_hero_nft_right_btm_btn2">Explore</a>
                                        <a href="create" className="_hero_nft_right_btm_btn3"> Create <span><svg xmlns="http://www.w3.org/2000/svg" width={12} height={11} fill="none" viewBox="0 0 12 11">
                                            <path fill="#151515" d="M9.997 3.035 2.04 10.107.734 8.945 8.69 1.874H1.68V.23h10.167v9.038h-1.85V3.035Z" />
                                        </svg>
                                        </span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                {/* <section className="_second_sec">
                    <div className="_secnd_sec_wrapper">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <div className="_second_sec_left">
                                        <h4 className="_second_sec_left_title">EARN UP TO <span className="_second_sec_left_title_cl">58,12%
                                            APY
                                        </span>
                                            WITH AB TOKENS
                                        </h4>
                                    </div>
                                </div>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <div className="_second_sec_right">
                                        <p className="_second_sec_right_txt">Stake AB Tokens to earn a share daily trading fees, in
                                            addition
                                            to multiple possibilities to earn even more AB Tokens from
                                            NFTs trading on Ethereum, Solana, Tezos, Cardano, Avalanche,
                                            Tron, BSC</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            <section className="_third_sec">
                <div className="_third_sec_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div data-aos="flip-left" data-aos-duration="2000" className="_third_sec_card">
                                    <img src="assets/img/homeic1.svg" alt="allblocks" className="_third_sec_card_ic" />
                                    <h3 className="_third_sec_title">Creators</h3>
                                    <p className="_third_sec_subtitle">Upload their artwork and list the
                                        NFT with Lazy Mint</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div data-aos="flip-right" data-aos-duration="2000" className="_third_sec_card">
                                    <img src="assets/img/homeic2.svg" alt="allblocks" className="_third_sec_card_ic" />
                                    <h3 className="_third_sec_title">Creators</h3>
                                    <p className="_third_sec_subtitle">Select the blockchain of their
                                        Choice to mint the NFT</p>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div data-aos="flip-up" data-aos-duration="2000" className="_third_sec_card">
                                    <img src="assets/img/homeic3.svg" alt="allblocks" className="_third_sec_card_ic" />
                                    <h3 className="_third_sec_title">Creators</h3>
                                    <p className="_third_sec_subtitle">Upload their artwork and list the
                                        NFT with Lazy Mint</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section data-aos="zoom-in" data-aos-duration="2000" className="_fourth_sec">
                <div className="_fourth_sec_wrapper">
                    <div className="container">
                        <div className="col-12">
                            <h3 className="_fourth_sec_title">Connected and trusted by the encosystem to break boundaries by linking
                                chains.</h3>
                            <img src="assets/img/cl1.png" alt="allblocks" className="_fourth_sec_img" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="_spot_sec">
                <div className="_spot_sec_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="_spot_sec_title">Spotlight</h2>
                            </div>
                            <div className="col-12">
                                <div className="_spot_sec_cards_wrap">
                                    <div className="row">
                                        <SpotCard />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="_upc_sec">
                <div className="_upc_sec_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="_upc_sec_title">Upcoming</h2>
                            </div>
                            <div className="col-12">
                                <div className="_upc_sec_cards_wrap">
                                    <div className="row">
                                        <UpcomingCard />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* upcoming section ends */}
            {/* collection start */}
            <section className="_coll_sec">
                <div className="_coll_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="_coll_title">Top Collections Over Last 7 Days</h2>
                            </div>
                            <div className="col-12">
                                <div className="_coll_main_wrapper">
                                    <div className="row">
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_coll_left_wrapper">
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">1</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c1.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <a href="nft-collection" className="_coll_det_wrap">
                                                        <h5 href="nft" className="_coll_det_title">Bold Automaton</h5>
                                                        <p className="_coll_det_amo">$16,579</p>
                                                    </a>
                                                </div>
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">2</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c2.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">Sandbox's LANDs</h5>
                                                        <p className="_coll_det_amo">$13,556</p>
                                                    </div>
                                                </div>
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">3</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c3.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">MutantApeYachtClub</h5>
                                                        <p className="_coll_det_amo">$1,694,027</p>
                                                    </div>
                                                </div>
                                                <img src="assets/img/line.svg" alt="allblocks" className="_coll_line" />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_coll_left_wrapper">
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">4</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c4.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">Bold Automaton</h5>
                                                        <p className="_coll_det_amo">$16,579</p>
                                                    </div>
                                                </div>
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">5</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c5.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">Sandbox's LANDs</h5>
                                                        <p className="_coll_det_amo">$13,556</p>
                                                    </div>
                                                </div>
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">6</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c6.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">MutantApeYachtClub</h5>
                                                        <p className="_coll_det_amo">$1,694,027</p>
                                                    </div>
                                                </div>
                                                <img src="assets/img/line.svg" alt="allblocks" className="_coll_line" />
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_coll_left_wrapper">
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">7</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c7.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">Bold Automaton</h5>
                                                        <p className="_coll_det_amo">$16,579</p>
                                                    </div>
                                                </div>
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">8</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c8.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">Sandbox's LANDs</h5>
                                                        <p className="_coll_det_amo">$13,556</p>
                                                    </div>
                                                </div>
                                                <div className="_coll_left_wrap">
                                                    <p className="_coll_left_num">9</p>
                                                    <div className="_coll_img_wrap">
                                                        <img src="assets/img/c9.png" alt="allblocks" className="_coll_img" />
                                                        <img src="assets/img/medal.svg" alt="allblocks" className="_coll_medal" />
                                                    </div>
                                                    <div className="_coll_det_wrap">
                                                        <h5 className="_coll_det_title">MutantApeYachtClub</h5>
                                                        <p className="_coll_det_amo">$1,694,027</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* collection ends */}
            {/* category start */}
            <section className="_cat_sec">
                {
                    darkMode && (
                        <div className="_dark_nft_shape _dark_nft_shape_left">

                        </div>
                    )
                }
                <div className="_cat_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="_cat_title">Browse by Category</h2>
                            </div>
                            <div className="col-12">
                                <div className="_cat_main_wrapper">
                                    <div className="row">
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                                <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat1.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Arts</h4>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat2.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Collectibles</h4>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat3.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Domain names</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="_cat_main_wrapper">
                                    <div className="row">
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat4.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Arts</h4>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat5.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Collectibles</h4>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat6.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Domain names</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="_cat_main_wrapper">
                                    <div className="row">
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat1.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Arts</h4>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat2.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Collectibles</h4>
                                            </div>
                                        </div>
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat3.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Domain names</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="_cat_main_wrapper">
                                    <div className="row justify-content-center">
                                        <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                            <div className="_cat_main_card">
                                            <a href="explore" className="_cat_main_card_img_wrap">
                                                    <img src="assets/img/cat5.png" alt="allblocks" className="_cat_main_card_img" />
                                                </a>
                                                <h4 className="_cat_main_card_title">Physical Assets</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* category ends */}
            {/* auction start */}
            <section className="_auc_sec">
                {
                    darkMode && (
                        <div className="_dark_nft_shape _dark_nft_shape_right">

                        </div>
                    )
                }
                <div className="_auc_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="_cat_title">Trending Auction now</h2>
                            </div>
                        </div>
                        <HomeSlider />
                        {/* <div className="_auction_slider_wrapper _auc_slider">
                            <HomeSlider/>
                        </div> */}
                    </div>
                </div>
            </section>
            {/* auction ends */}
            {/* partner start */}
            <section className="_par_sec">
                <div className="_par_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="_par_title">Our Partners</h2>
                            </div>
                        </div>
                    </div>
                    <div className="_par_logo_wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="_par_logo_main_wrap">
                                        <img src="assets/img/par1.png" alt="allblocks" className="_par_logo_img" />
                                        <img src="assets/img/par2.png" alt="allblocks" className="_par_logo_img" />
                                        <img src="assets/img/par3.png" alt="allblocks" className="_par_logo_img" />

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* partner ends */}
            {/* trending start */}
            <section className="_trend_sec">
                {
                    darkMode && (
                        <div className="_dark_nft_shape _dark_nft_shape_left2">

                        </div>
                    )
                }
                <div className="_trend_wrapper">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="_trend_title">Trending in <span className="_trend_title_grad"> all categories</span></h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                <div className="_trend_card">
                                    <a href="mycollection" className="_trend_card_top">
                                        <img src="assets/img/trend1.png" alt="allblocks" className="_trend_card_top_img" />
                                    </a>
                                    <img src="assets/img/trend11.png" alt="allblocks" className="_trend_card_mid_img" />
                                    <div className="_trend_card_btm">
                                        <div className="_trend_card_btm_head_wrap">
                                            <h4 className="_trend_card_btm_head_title">ETHEREALS WTF</h4>
                                            <p className="_trend_card_btm_head_sub">by Souravwpap</p>
                                            <img src="assets/img/verifyic.png" alt="allblocks" className="_trend_card_btm_head_ic" />
                                        </div>
                                        <p className="_trend_card_btm_txt">ETHEREALS are 12,345 hand drawn, randomly
                                            generated, interdimensional ghosts.
                                            Their traits are pulle...</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                <div className="_trend_card">
                                    <div className="_trend_card_top">
                                        <img src="assets/img/trend2.png" alt="allblocks" className="_trend_card_top_img" />
                                    </div>
                                    <img src="assets/img/trend22.png" alt="allblocks" className="_trend_card_mid_img" />
                                    <div className="_trend_card_btm">
                                        <div className="_trend_card_btm_head_wrap">
                                            <h4 className="_trend_card_btm_head_title">Avengaer NFT</h4>
                                            <p className="_trend_card_btm_head_sub">by Frensware</p>
                                            <img src="assets/img/verifyic.png" alt="allblocks" className="_trend_card_btm_head_ic" />
                                        </div>
                                        <p className="_trend_card_btm_txt">ETHEREALS are 12,345 hand drawn, randomly
                                            generated, interdimensional ghosts.
                                            Their traits are pulle...</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                                <div className="_trend_card">
                                    <div className="_trend_card_top">
                                        <img src="assets/img/trend3.png" alt="allblocks" className="_trend_card_top_img" />
                                    </div>
                                    <img src="assets/img/trend33.png" alt="allblocks" className="_trend_card_mid_img" />
                                    <div className="_trend_card_btm">
                                        <div className="_trend_card_btm_head_wrap">
                                            <h4 className="_trend_card_btm_head_title">GOSTBOX WTF</h4>
                                            <p className="_trend_card_btm_head_sub">by PunkArt</p>
                                            <img src="assets/img/verifyic.png" alt="allblocks" className="_trend_card_btm_head_ic" />
                                        </div>
                                        <p className="_trend_card_btm_txt">ETHEREALS are 12,345 hand drawn, randomly
                                            generated, interdimensional ghosts.
                                            Their traits are pulle...</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* trending ends */}
            {/* Modal */}
            <div class="modal fade _home_modal_wrap" id="connectModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog _home_modal_dlg">
                    <div class="modal-content _home_modal_content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">
                                You’ll need wallet on
                                Elementalanalytics
                                to continue
                            </h5>
                            <button type="button" class="btn-close _home_modal_close_btn" data-bs-dismiss="modal" aria-label="Close">
                                {/* Close Button */}
                            </button>
                        </div>
                        <div class="modal-body _home_modal_body">
                            <ul className="_home_modal_body_ul">
                                <li className="_home_modal_body_li">
                                    <span className="_home_modal_body_li_txt_wrap">
                                        <span className="_home_modal_body_img_wrap">
                                            <img src="assets/img/modal1.png" alt="" className="_home_modal_body_img" />
                                        </span>
                                        <span className="_home_modal_body_txt">
                                            Sollet
                                        </span>
                                    </span>
                                    <span className="_home_modal_body_li_txt2_wrap">
                                        <span className="_home_modal_body_txt">
                                            Detected
                                        </span>
                                    </span>
                                </li>
                                <li className="_home_modal_body_li">
                                    <span className="_home_modal_body_li_txt_wrap">
                                        <span className="_home_modal_body_img_wrap">
                                            <img src="assets/img/modal2.png" alt="" className="_home_modal_body_img" />
                                        </span>
                                        <span className="_home_modal_body_txt">
                                            Sollet( Extension )
                                        </span>
                                    </span>
                                </li>
                                <li className="_home_modal_body_li">
                                    <span className="_home_modal_body_li_txt_wrap">
                                        <span className="_home_modal_body_img_wrap">
                                            <img src="assets/img/modal3.png" alt="" className="_home_modal_body_img" />
                                        </span>
                                        <span className="_home_modal_body_txt">
                                            Slope
                                        </span>
                                    </span>
                                </li>
                                <li className="_home_modal_body_li">
                                    <span className="_home_modal_body_li_txt_wrap">
                                        <span className="_home_modal_body_img_wrap">
                                            <img src="assets/img/modal4.png" alt="" className="_home_modal_body_img" />
                                        </span>
                                        <span className="_home_modal_body_txt">
                                            Torus
                                        </span>
                                    </span>
                                </li>
                                <li className="_home_modal_body_li">
                                    <span className="_home_modal_body_li_txt_wrap">
                                        <span className="_home_modal_body_img_wrap">
                                            <img src="assets/img/modal5.png" alt="" className="_home_modal_body_img" />
                                        </span>
                                        <span className="_home_modal_body_txt">
                                            Solflare
                                        </span>
                                    </span>
                                </li>
                                <li className="_home_modal_body_li">
                                    <span className="_home_modal_body_li_txt_wrap">
                                        <span className="_home_modal_body_img_wrap">
                                            <img src="assets/img/modal6.png" alt="" className="_home_modal_body_img" />
                                        </span>
                                        <span className="_home_modal_body_txt">
                                            Ledger
                                        </span>
                                    </span>
                                </li>
                            </ul>
                            <div className="_home_modal_drop_wrap">
                                <div class="dropdown">
                                    <button class="btn dropdown-toggle _modal_drop_btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        Last Options
                                    </button>
                                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a class="dropdown-item" href="#0">Action</a></li>
                                        <li><a class="dropdown-item" href="#0">Another action</a></li>
                                        <li><a class="dropdown-item" href="#0">Something else here</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Modal */}
        </div>
    )
}
export default Home;